export default __webpack_public_path__ + "static/media/logo.278b73e4.png";